import type { ReactNode } from 'react'
import styles from './primitives.module.css'

export default function Eyebrow({
  children,
  moss = false,
  dot = false,
  className,
}: {
  children: ReactNode
  moss?: boolean
  dot?: boolean
  className?: string
}) {
  const cls = [styles.eyebrow, moss && styles.eyebrowMoss, dot && styles.eyebrowDot, className]
    .filter(Boolean)
    .join(' ')
  return <span className={cls}>{children}</span>
}
